import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

import { PtAuthSessionService } from '@pt/services/auth';

@Component({
  selector: 'app-user-profile',
  imports: [ButtonModule, TooltipModule, TranslocoDirective],
  templateUrl: './user-profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex',
  },
})
export class UserProfileComponent {
  private readonly authSession = inject(PtAuthSessionService);
  private readonly router = inject(Router);

  /** Controls whether to show compact layout (for mobile header). */
  readonly compact = input(false);

  /** Current authenticated user. */
  readonly user = this.authSession.user;

  /** Handles logout action. */
  async onLogout(): Promise<void> {
    await this.authSession.signOut();
    await this.router.navigate(['/sign-in']);
  }
}
